import Vue from 'vue'
import Router from 'vue-router'
import Login from "./components/Login.vue"
import Home from "./components/Home";
import Dashboard from "./components/Dashboard";
import Logout from "./components/Logout";
import Gateways from "./components/gateways/Gateways";
import GatewayForm from "./components/gateways/GatewayForm";
import GatewayDetails from "./components/gateways/GatewayDetails";
import DevicesList from "./components/devices/DevicesList";
import DeviceForm from "./components/devices/DeviceForm";
import DeviceDetails from "./components/devices/DeviceDetails";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "",
            name: "login",
            component: Login
        },
        {
            path: "/logout",
            name: "logout",
            component: Logout
        },
        {
            path: "/home",
            component: Home,
            children: [
                {path: "", name: "home", component: Dashboard},
                {path: "/gateways", component: Gateways},
                {path: "/gateway/form", name: "gatewayRegister", component: GatewayForm, props: true},
                {path: "/gateway/form/:id", name: "gatewayEdit", component: GatewayForm, props: true},
                {path: "/gateway/details/:id", name: "gatewayDetails", component: GatewayDetails, props: true},
                {path: "/devices", component: DevicesList},
                {path: "/device/form", name: "deviceRegister", component: DeviceForm, props: true},
                {path: "/device/form/:id", name: "deviceEdit", component: DeviceForm, props: true},
                {path: "/device/details/:id", name: "deviceDetails", component: DeviceDetails, props: true}
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (localStorage.getItem("authKey") === null && to.name !== "login") {
        next({name: "login"});
    } else {
        next();
    }
});

export default router;